import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../common/Icons';
import ArticleHeader from '../Heading/Heading';
import IframePopUp from '../IframePopUp/IframePopUp';
import useScreenSize from '../../core/hooks/useScreenSize';
import { useNavigate } from 'react-router-dom';
import { useModalContext } from '../../core/context/ModalContext';
import {
  StyledBanner,
  StyledButton,
  StyledContent,
  StyledImage,
  StyledBackButton,
  StyledVideo,
} from './Banner.styles';

function Banner({ data }) {
  const [size] = useScreenSize();
  const navigate = useNavigate();
  const [source, setSource] = useState('');
  const [provider, setProvider] = useState('');
  const { createModal } = useModalContext();

  const { element: IframeModal, close, open } = useMemo(() => createModal(false), [createModal]);

  const closeModal = useCallback(() => {
    close();
  }, [close]);

  const onClick = useCallback(
    (videoSource, videoProvider) => {
      if (!videoSource) return;
      setSource(videoSource);
      setProvider(videoProvider);
      open();
    },
    [open]
  );

  if (!data) return null;

  return (
    <>
      <StyledBanner borderColor={data.borderColor}>
        {data.img && !data.bgVideo && <StyledImage src={data.img} alt={data.alt} />}
        {data.bgVideo && (
          <StyledVideo muted autoPlay loop playsInline>
            <source src={data.bgVideo.src} type={data.bgVideo.type} />
          </StyledVideo>
        )}
        <StyledContent>
          <div>
            {size > 991 && (
              <StyledBackButton onClick={() => navigate(-1)}>
                <span className="sr-only">Go back</span>
                <Icon.Arrow aria-hidden />
              </StyledBackButton>
            )}
            <ArticleHeader title={data.title} type="h1" styling="h1" />
            {data.description && size > 991 && <p>{data.description}</p>}
          </div>
          {data.video && (
            <StyledButton onClick={() => onClick(data.video.src, data.video.provider)}>
              {data.button}
              <Icon.Arrow aria-hidden />
            </StyledButton>
          )}
        </StyledContent>
      </StyledBanner>

      <IframeModal>
        <IframePopUp source={source} provider={provider} onClose={closeModal} />
      </IframeModal>
    </>
  );
}

Banner.propTypes = {
  data: PropTypes.object,
};

export default Banner;
